import { faBinoculars, faTelescope } from '@fortawesome/pro-duotone-svg-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ProjectId, UserType } from 'api/models';
import {
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { useUserType } from 'hooks/use-user-type';
import { getProjectPlanUrl } from 'utils/urls';

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  && {
    text-align: left;
  }
`;

interface Params {
  projectId: string;
}

export const NoResponsesEmptyState = () => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={<EmptyStateIcon icon={faTelescope} />}
        title={
          <FormattedMessage id="projects.form_responses.no_answers.title" />
        }
        message={
          <FormattedMessage id="projects.form_responses.no_answers.message" />
        }
        secondaryCTA={null}
      />
    </EmptyStateContainer>
  );
};

export const NoInstancesEmptyState = () => {
  const { projectId } = useParams<Params>();

  const userType = useUserType();
  const isUserNative = userType === UserType.Native;

  return (
    <EmptyStateContainer>
      {isUserNative ? (
        <EmptyState
          image={<EmptyStateIcon icon={faBinoculars} />}
          title={
            <FormattedMessage id="projects.form_responses.no_instances.title" />
          }
          message={
            <FormattedMessage id="projects.form_responses.no_instances.message" />
          }
          secondaryCTA={
            <Link to={getProjectPlanUrl(ProjectId(Number(projectId)))}>
              <FormattedMessage id="projects.form_responses.no_instances.cta" />
            </Link>
          }
        />
      ) : (
        <EmptyState
          image={<EmptyStateIcon icon={faBinoculars} />}
          title={
            <FormattedMessage id="projects.form_responses.customer_view.no_instances.title" />
          }
          message={
            <FormattedMessage id="projects.form_responses.customer_view.no_instances.message" />
          }
        />
      )}
    </EmptyStateContainer>
  );
};
